__turbopack_context__.v({
  "calendarIcon": "date-range-picker-module-sass-module__TChtOq__calendarIcon",
  "dateRangePicker": "date-range-picker-module-sass-module__TChtOq__dateRangePicker",
  "dateRangePickerContainer": "date-range-picker-module-sass-module__TChtOq__dateRangePickerContainer",
  "dateRangePickerContent": "date-range-picker-module-sass-module__TChtOq__dateRangePickerContent",
});
